import React from 'react';

interface IProps {
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent) => void;
  className?: string;
}

export const FormContainer = ({ children, onSubmit, className = '' }: IProps) => (
  <form onSubmit={onSubmit} className={`flex flex-col ${className}`}>
    {children}
  </form>
);
